export default __webpack_public_path__ + "static/investment-grid-background-cities-428765ec3366dd75f95615fbea401f4f.jpg";